 
import CallPanel from ".";
import { useCall } from "../../../hooks/useCallSocket";

const CallModule = () => {
  const { activeCall, acceptCall, declineCall, closeCall, updateActiveCall } = useCall();

  if (!activeCall?.isOpen) return null;

  return (
    <CallPanel
      call={activeCall}
      onAccept={acceptCall}
      onDecline={declineCall}
      onClose={closeCall}
      onUpdateCall={updateActiveCall}
    />
  );
};

export default CallModule;
